import { ToastContainerProps } from 'react-toastify';

export const EMPTY_VALUE_REPRESENTATION = '---';

export const IMPORT_FILES_ACCEPT_STRING = [
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
].join(',');

export const MAX_FILE_SIZE_MB = 150;

export const MAX_PREVIEW_FILE_SIZE_MB = 5;

export const FILES_ACCEPT_STRING = [
  'image/png',
  'image/jpeg',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
].join(',');

export const MAX_COMMENT_CONTENT_LENGTH = 130;

export const TOAST_CONFIG: ToastContainerProps = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: 'light',
  style: {
    width: 'max-content',
    maxWidth: '50%',
    minWidth: '300px',
  },
};

export const DATE_FORMAT = 'YYYY-MM-DD';

export const TIME_FORMAT = 'HH:mm';

export const DATE_TIME_FORMAT = 'HH:mm MM.DD.YYYY';

export const DEFAULT_REQUESTS_PARAMS = { page: 1, per_page: 10, sort: null };

export const ALLOWED_PRESET_TO_CREATE_LENGTH = 5;

export const colors = {
  darkViolet: '#21005D',
  violet: '#654AFB',
  white: '#fff',
  black: '#141415',
};

export const RE_FETCH_REQUEST_TIME_OUT = 5000;
